import { AccountsGateway } from "gateways/accounts.gateway";
import { LoginService } from "services/login.service";
import { UserService } from "services/user.service";

console.info("[Services] Initialising services...");

// Accounts:
export const accountsGateway = new AccountsGateway();
export const loginService = new LoginService(accountsGateway.socket);
export const userService = new UserService(accountsGateway.socket);